import { ComponentType } from '@angular/cdk/portal';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatSelectionList, MatSelectionListChange } from '@angular/material/list';
import { take, tap } from 'rxjs/operators';
import { WindowService } from 'src/app/shared/components/window/window.service';
import { SimulationFormComponent } from '../simulation-form/simulation-form.component';
import { Simulation, SimulationStatus } from '../state/simulation.model';
import { SimulationQuery } from '../state/simulation.query';
import { SimulationService } from '../state/simulation.service';
import {interval, Subscription} from 'rxjs';

@Component({
  selector: 'app-simulation-list',
  templateUrl: './simulation-list.component.html',
  styleUrls: ['./simulation-list.component.scss']
})
export class SimulationListComponent implements OnInit, OnDestroy {

  isLoading$ = this.simulationQuery.isLoading$;
  simulations$ = this.simulationQuery.simulations$;
  simulationActive$ = this.simulationQuery.active$;
  SimulationStatus = SimulationStatus;
  simulations: Simulation[];
  canCompare: boolean;
  selecteds: Simulation[] = [];
  updateStatusTimer: Subscription;
  @ViewChild('selectionsList') selectionsList: MatSelectionList;

  constructor(
    private simulationQuery: SimulationQuery,
    private simulationService: SimulationService,
    private windowService: WindowService
  ) { }


  ngOnInit(): void {
    this.updateStatus();
    this.simulationActive$.pipe(
      tap(() => this.clearSelection())
    );
    this.simulationActive$.subscribe(sim =>
      {
        console.log("sim recebida = " + sim);
        if (! sim && ! this.updateStatusTimer) {
          this.startUpdateTimer();
        } else if (sim && this.updateStatusTimer) {
          this.stopUpdateTimer();
        }
      });
    this.simulations$.subscribe(simulations => this.simulations = simulations);
    // this.startUpdateTimer();
  }

  startUpdateTimer(): void {
    this.updateStatusTimer = interval(5000).subscribe(val => this.updateStatus());
  }

  ngOnDestroy(): void {
    this.simulationService.clear();
    if (this.updateStatusTimer) {
      this.updateStatusTimer.unsubscribe();
    }
  }

  new() {
    this.clearSelection();
    this.open($localize`NEW NETWORK`, SimulationFormComponent, null, 'CREATE_NETWORKS');
  }

  updateStatus() {
    // this.clearSelection();
    if (this.selecteds.length === 0) {
      this.load();
    }
  }

  select(id: number) {
    this.stopUpdateTimer();
    this.simulationService.getById(id)
      .subscribe(s => this.simulationService.active(s.id));
  }

  stopUpdateTimer(): void {
    this.updateStatusTimer.unsubscribe();
    this.updateStatusTimer = null;
    this.clearSelection();
  }

  duplicate() {
    const selectedId = this.selecteds[0].id;
    this.simulationService.getById(selectedId)
      .pipe(take(1))
      .subscribe(s => {
        this.simulationService.duplicate(s).subscribe(newSimulation => {
          this.stopUpdateTimer();
          this.simulationService.active(newSimulation.id);
        });
      });
  }

  clearSelection() {
    this.selecteds = [];
    if (this.selectionsList) {
      this.selectionsList.deselectAll();
    }
  }

  selectionChange(event: MatSelectionListChange) {
    if (event.option.selected) {
      this.selecteds.push(event.option.value);
    } else {
      const i = this.selecteds.indexOf(event.option.value);
      this.selecteds.splice(i, 1);
    }
    const countDone = this.selecteds.reduce(
      (previous, current, i, arr) => {
        if (current.status === SimulationStatus.DONE) {
          return previous + 1;
        }
        return previous;
      },
      0
    );
    this.canCompare = countDone > 1;
  }

  private load() {
    this.simulationService.get().pipe(take(1)).subscribe();
  }

  private open(title: string, componentType: ComponentType<any>, data: Simulation, help?: string) {
    this.windowService.open({ title, componentType, config: { data }, help });
  }

}
